export const operating_systems = [
  {
    img: '/services/compute/RedHat.webp',
    name: 'Red Hat Enterpise Linux',
    className: 'redhat'
  },
  {
    img: '/services/compute/CentOS.webp',
    name: 'CentOS'
  },
  {
    img: '/services/compute/Debian.webp',
    name: 'Debian'
  },
  {
    img: '/services/compute/Windows.webp',
    name: 'Windows'
  },
  {
    img: '/services/compute/Ubuntu.webp',
    name: 'Ubuntu'
  },
  {
    img: '/services/compute/WS.webp',
    name: 'Windows server',
    className: 'server'
  }
];

export const click_apps = [
  {
    img: '/services/compute/wordpress.webp',
    name: 'Wordpress'
  },
  {
    img: '/services/compute/node.webp',
    name: 'Node.js'
  },
  {
    img: '/services/compute/joomla3.webp',
    name: 'Joomla3'
  },
  {
    img: '/services/compute/mysql.webp',
    name: 'mySQL'
  },
  {
    img: '/services/compute/redmine.webp',
    name: 'Redmine'
  },
  {
    img: '/services/compute/owncloud.webp',
    name: 'OwnCloud'
  }
];
